import { gql } from '@optools/services/operator-gateway/types/generated';

export const ASSIGN_DEV_PIPELINE_CONFIG = gql(`
  mutation assignDevPipelineConfig($teamId: Int!, $pipelineId: Int!) {
    assignDevPipelineConfig(teamId: $teamId, pipelineId: $pipelineId)
  }
`);

export const BORROW_PIPELINE = gql(`
  mutation borrowPipeline($teamId: Int!) {
    borrowPipeline(teamId: $teamId)
  }
`);

export const RETURN_PIPELINE = gql(`
  mutation returnPipeline($teamId: Int!) {
    returnPipeline(teamId: $teamId)
  }
`);
